<template>
  <div>
    <LmFormSubtitles
      class="col-12 mt-3"
      text="Propiedades basadas en modo edición"
      />
    <LmCheckbox
      class="col-12"
      v-model="component.componentProps.isVisibleOnlyOnEditMode"
      labelSingle="Visible solo en modo edición"
      @input="$emit('input', component)"
      />
    <LmCheckbox
      class="col-12"
      v-model="component.componentProps.isDisabledOnlyOnEditMode"
      labelSingle="Deshabilitado solo en modo edición"
      @input="$emit('input', component)"
      />
  </div>
</template>

<script>
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmFormSubtitles from '@/components/form/elements/LmFormSubtitles'

export default {
  props: {
    component: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    LmCheckbox,
    LmFormSubtitles
  }
}
</script>
